import { render } from "./PruefkriterienEditDetails.pug?vue&type=template&id=68b2ba5e&lang=pug"
import script from "./PruefkriterienEditDetails.js?vue&type=script&lang=js"
export * from "./PruefkriterienEditDetails.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__